<template>
  <div>
    <b-row>
      <b-col md="4">
        <b-card no-body>
          <b-card-header>
            <b-card-title>
              <h4 class="mb-0 text-center">
                {{ $t("objects.information") }}
              </h4>
            </b-card-title>
            <b-dropdown
              v-if="GET_USER_PERMISSIONS.includes('content_management')"
              variant="link"
              no-caret
              class="chart-dropdown"
              toggle-class="p-0"
              right
            >
              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="18"
                  class="text-body cursor-pointer"
                />
              </template>
              <b-dropdown-item
                @click="
                  $router.push({
                    name: 'object-edit',
                    params: { id: $route.params.id },
                  })
                "
              >
                <feather-icon icon="EditIcon" size="18" />
                {{ $t("generals.edit") }}
              </b-dropdown-item>
              <b-dropdown-item href="#" @click="deactivateObject">
                <feather-icon icon="TrashIcon" size="18" />
                {{ $t("generals.delete") }}
              </b-dropdown-item>
            </b-dropdown>
          </b-card-header>
          <b-card-body class="pt-50">
            <decsription-list
              module_prefix="objects"
              :desc_list="GET_OBJECT_MAIN_INFO"
            />
          </b-card-body>
        </b-card>
        <b-card no-body>
          <b-card-header class="pb-0">
            <h4 class="mb-0 text-center">
              {{ $t("objects.media_materials") }}
              <b-badge>
                {{ GET_OBJECT_MEDIA.video.length }}
              </b-badge>
            </h4>
            <div>
              <b-button
                size="sm"
                variant="primary"
                @click="
                  $router.push({
                    name: 'object-edit-media',
                    params: { id: $route.params.id },
                  })
                "
              >
                {{ $t("objects.detail") }}
              </b-button>
            </div>
          </b-card-header>
          <div
            v-if="
              !GET_OBJECT_MEDIA.links.length && !GET_OBJECT_MEDIA.video.length
            "
            class="d-flex flex-column mt-2 mb-2 align-items-center justify-content-center"
          >
            <p class="text-muted">
              {{ $t("objects.video_material_not_uploaded") }}
            </p>
          </div>
          <div v-else>
            <b-row class="p-2">
              <b-col
                v-for="video in GET_OBJECT_MEDIA.video"
                :key="video.id"
                md="6"
                class="mb-2"
              >
                <b-embed
                  type="video"
                  aspect="16by9"
                  style="background-color: #000"
                  :src="video.file_link"
                  @click="
                    $router.push({
                      name: 'object-edit-media',
                      params: { id: $route.params.id },
                    })
                  "
                />
              </b-col>
            </b-row>
          </div>
        </b-card>
        <b-card v-if="GET_USER_PERMISSIONS.includes('content_management')">
          <div class="d-flex justify-content-between">
            <b-button
              variant="warning"
              class="mx-1"
              @click="
                $router.push({
                  name: 'object-price-history',
                  params: {
                    id: $route.params.id,
                  },
                })
              "
            >
              {{ $t("objects.view_price_history") }}
            </b-button>
            <b-button
              variant="primary"
              class="mx-1"
              @click="
                $router.push({
                  name: 'object-discount-history',
                  params: { id: $route.params.id },
                })
              "
            >
              {{ $t("objects.view_discount_history") }}
            </b-button>
          </div>
        </b-card>
      </b-col>
      <b-col md="8">
        <b-card no-body>
          <b-card-header>
            <b-card-title>
              {{ $t("objects.list_hause") }}
            </b-card-title>
            <b-button
              v-if="GET_USER_PERMISSIONS.includes('content_management')"
              v-b-modal.validated-form-modal
              size="sm"
              variant="primary"
            >
              <feather-icon icon="PlusIcon" />
              {{ $t("objects.new_house") }}
            </b-button>
          </b-card-header>
          <b-row class="mx-1">
            <b-col
              v-for="apartment in GET_APARTMENTS"
              :key="apartment.id"
              md="6"
            >
              <apartment-card
                :apartment_info="apartment"
                @deactivated="
                  FETCH_APARTMENTS_BY_OBJECT({ id: $route.params.id })
                "
              />
            </b-col>
          </b-row>
        </b-card>
        <b-card :title="$t('objects.allowed_payment_methods')">
          <b-form-group v-slot="{ ariaDescribedby }">
            <b-form-checkbox-group
              v-if="mounted"
              v-model="GET_ONE_OBJECT.payment_type"
              :options="GET_PAYMENT_TYPES"
              :aria-describedby="ariaDescribedby"
              :text-field="`title.${$i18n.locale}`"
              value-field="id"
              switches
              :disabled="!GET_USER_PERMISSIONS.includes('content_management')"
              @change="changePaymentTypes"
            />
          </b-form-group>
        </b-card>
        <b-card no-body>
          <b-card-header>
            <h4>{{ $t("objects.calculations_discount") }}</h4>
            <b-button
              v-b-modal.add-object-calculations
              variant="primary"
              size="sm"
              @click="editOffice(props.item)"
            >
              <feather-icon icon="PlusIcon" />
            </b-button>
          </b-card-header>
          <b-card-body>
            <b-row>
              <b-col
                v-for="payment_option in GET_OBJECT_CALCULATIONS"
                :key="payment_option.initial_payment.id"
                md="6"
              >
                <b-table
                  class="mb-1"
                  bordered
                  :items="payment_option.options"
                  :fields="fields"
                >
                  <template #thead-top>
                    <b-tr>
                      <b-th colspan="3">
                        <div
                          class="d-flex justify-content-between align-items-center"
                        >
                          <div></div>
                          {{ payment_option.initial_payment.value }} %
                          {{ $t("objects.prepayment") }}
                          <div
                            @click="
                              deletePayment(payment_option.initial_payment.id)
                            "
                            class="cursor-pointer"
                          >
                            <feather-icon
                              icon="TrashIcon"
                              class="text-danger"
                            />
                          </div>
                        </div>
                      </b-th>
                    </b-tr>
                  </template>
                  <template #empty>
                    <div class="text-center">
                      {{ $t("general.no_records_to_show") }}
                    </div>
                  </template>
                  <template #cell(range)="props">
                    <b-button :id="`range-${props.item.id}`" variant="link">
                      {{ `${props.item.start}-${props.item.end}` }} м²
                      {{
                        props.item.is_duplex ? `+ ${$t("objects.floor")}` : ""
                      }}
                    </b-button>
                    <b-popover
                      :target="`range-${props.item.id}`"
                      triggers="focus"
                      placement="top"
                    >
                      <template #title>
                        {{ $t("objects.range") }}
                      </template>
                      <div class="d-flex">
                        <div class="mr-1">
                          <label for="range-start">{{
                            $t("objects.with")
                          }}</label>
                          <b-form-input
                            id="range-start"
                            v-model="props.item.start"
                          />
                        </div>
                        <div>
                          <label for="range-start">{{
                            $t("objects.by")
                          }}</label>
                          <b-form-input
                            id="range-end"
                            v-model="props.item.end"
                          />
                        </div>
                      </div>
                      <div class="mt-50 d-flex">
                        <b-button
                          variant="primary"
                          size="sm"
                          class="ml-auto"
                          @click="saveRange(props.item)"
                        >
                          {{ $t("generals.ok") }}
                        </b-button>
                      </div>
                    </b-popover>
                  </template>
                  <template #cell(discount)="props">
                    <b-button
                      :id="`popover-discount-${props.item.id}`"
                      variant="link"
                    >
                      {{ props.item.discount }}%
                    </b-button>
                    <b-popover
                      :target="`popover-discount-${props.item.id}`"
                      triggers="focus"
                      placement="top"
                    >
                      <template #title>
                        {{ $t("objects.discount") }}
                      </template>
                      <b-form-input
                        id="discount"
                        v-model="props.item.discount"
                      />
                      <div class="mt-50 d-flex">
                        <b-button
                          variant="primary"
                          size="sm"
                          class="ml-auto"
                          @click="saveRange(props.item)"
                        >
                          {{ $t("generals.ok") }}
                        </b-button>
                      </div>
                    </b-popover>
                  </template>
                  <template #cell(actions)="props">
                    <div
                      @click="deletePaymentOption(props.item.id)"
                      class="cursor-pointer"
                    >
                      <feather-icon icon="TrashIcon" class="text-danger" />
                    </div>
                  </template>
                  <template #custom-foot>
                    <b-tr>
                      <b-th colspan="3" class="text-center">
                        <b-button
                          v-if="
                            GET_USER_PERMISSIONS.includes('content_management')
                          "
                          v-b-modal.add-discount-option
                          variant="primary"
                          @click="
                            openOptionModal(payment_option.initial_payment.id)
                          "
                        >
                          {{ $t("generals.add") }}
                        </b-button>
                      </b-th>
                    </b-tr>
                  </template>
                </b-table>
              </b-col>
            </b-row>
            <h3 class="mt-2">
              {{ $t("objects.installment") }}
            </h3>
            <b-row>
              <b-col md="4">
                <flat-pickr
                  v-model="installment.start_date"
                  disabled
                  class="form-control bg-white"
                  style="max-width: 250px;"
                  :config="configdateTimePicker"
                />
              </b-col>
              <b-col md="4">
                <flat-pickr
                  v-if="mounted"
                  v-model="GET_ONE_OBJECT.installment_end_date"
                  :disabled="
                    !GET_USER_PERMISSIONS.includes('content_management')
                  "
                  class="form-control bg-white"
                  style="max-width: 250px;"
                  :config="configdateTimePicker"
                  @on-change="changeInstallmentDate"
                />
              </b-col>
              <b-col md="4">
                <b-form-input :value="getInstallment" disabled />
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-modal
      id="add-discount-option"
      :title="$t('objects.add_new_operation')"
      :ok-title="$t('generals.create')"
      :cancel-title="$t('generals.cancel')"
      @ok="saveClick"
    >
      <b-row>
        <b-col md="6">
          <b-form-group :label="$t('objects.area_with') + ':'">
            <b-form-input v-model="new_option.area_start" />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group :label="$t('objects.area_by') + ':'">
            <b-form-input v-model="new_option.area_end" />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group>
            <b-form-checkbox v-model="new_option.is_duplex" switch>
              + {{ $t("objects.floor") }}
            </b-form-checkbox>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group>
            <b-form-checkbox v-model="new_option.is_mortgage" switch>
              + {{ $t("objects.floor") }}
            </b-form-checkbox>
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group :label="$t('objects.discount') + ':'">
            <b-form-input v-model="new_option.discount_in_percent" />
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
    <add-new-apartment-modal
      :def-obj="{ rc_object: GET_ONE_OBJECT.id }"
      @save="FETCH_APARTMENTS_BY_OBJECT({ id: $route.params.id })"
    />

    <b-modal
      id="add-object-calculations"
      :title="$t('objects.prepayment')"
      :ok-title="$t('generals.create')"
      :cancel-title="$t('generals.cancel')"
      :ok-disabled="!new_initial_payment"
      @ok="saveInitialPayment"
    >
      <b-form-group :label="$t('objects.prepayment') + ' (%):'">
        <b-form-input v-model="new_initial_payment" />
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardTitle,
  BCardHeader,
  BButton,
  BEmbed,
  BBadge,
  BCardBody,
  BDropdown,
  BDropdownItem,
  BTable,
  BTr,
  BTh,
  BPopover,
  BFormInput,
  BFormGroup,
  BModal,
  BFormCheckboxGroup,
  BFormCheckbox,
  // BImg,
} from "bootstrap-vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import FeatherIcon from "@core/components/feather-icon/FeatherIcon.vue";
import flatPickr from "vue-flatpickr-component";
// eslint-disable-next-line import/no-extraneous-dependencies
import { Russian } from "flatpickr/dist/l10n/ru";
import apartmentCard from "@/components/apartmentCard.vue";
import addNewApartmentModal from "@/views/modules/MyObjects/components/modals/addOrEditApartmentModal.vue";
import decsriptionList from "@/components/descriptionList.vue";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardTitle,
    BBadge,
    BDropdown,
    BDropdownItem,
    BButton,
    BEmbed,
    FeatherIcon,
    BCardBody,
    BCardHeader,
    apartmentCard,
    addNewApartmentModal,
    decsriptionList,
    BTable,
    BTr,
    BTh,
    BPopover,
    BFormInput,
    BFormGroup,
    BModal,
    flatPickr,
    BFormCheckboxGroup,
    BFormCheckbox,
  },
  data() {
    return {
      fields: [
        {
          key: "range",
          label: this.$t("objects.range"),
        },
        {
          key: "discount",
          label: this.$t("objects.discount"),
        },
        {
          key: "actions",
          label: "",
          tdClass: "text-center",
        },
      ],
      installment: {
        start_date: new Date(),
        end_date: "2023-12-01",
      },
      new_option: {
        object: this.$route.params.id,
      },
      items: [
        {
          start: 0,
          end: 50,
          discount: 10,
        },
      ],
      configdateTimePicker: {
        altInput: true,
        altFormat: "d.m.Y",
        // parseDate: true,
        dateFormat: "Y-m-d",
        locale: Russian,
      },
      mounted: false,
      new_initial_payment: 0,
    };
  },
  computed: {
    ...mapGetters("objects", [
      "GET_ONE_OBJECT",
      "GET_OBJECT_MAIN_INFO",
      "GET_OBJECT_MEDIA",
      "GET_OBJECT_CALCULATIONS",
      "GET_PAYMENT_TYPES",
    ]),
    ...mapGetters("apartments", ["GET_APARTMENTS"]),
    ...mapGetters("knowledgeBase", ["GET_PAYMENT_INTERESTS"]),
    ...mapGetters("users", ["GET_USER_PERMISSIONS"]),
    getInstallment() {
      let months;
      months =
        (new Date(this.GET_ONE_OBJECT.installment_end_date).getFullYear() -
          new Date().getFullYear()) *
        12;
      months -= new Date().getMonth();
      months += new Date(this.GET_ONE_OBJECT.installment_end_date).getMonth();
      return months <= 0 ? 0 : months;
    },
  },
  created() {
    this.FETCH_ONE_OBJECT(this.$route.params.id)
      .then(() => {
        this.mounted = true;
        this.updateBreadcrumb();
      })
      .catch(() => {
        this.UPDATE_BREADCRUMB(this.$route.meta.breadcrumb);
      });
    this.FETCH_APARTMENTS_BY_OBJECT({ id: this.$route.params.id });
    // let { title, object_type, bank, currency, site }
    this.FETCH_OBJECT_CALCULATIONS(this.$route.params.id);
    this.FETCH_PAYMENT_INTERESTS();
    this.FETCH_PAYMENT_TYPES();
  },
  methods: {
    ...mapActions("objects", [
      "FETCH_ONE_OBJECT",
      "FETCH_OBJECTS",
      "EDIT_OBJECT",
      "FETCH_OBJECT_CALCULATIONS",
      "ADD_OBJECT_DISCOUNT_OPTION",
      "EDIT_OBJECT_DISCOUNT_OPTION",
      "FETCH_PAYMENT_TYPES",
    ]),
    ...mapActions("apartments", [
      "FETCH_APARTMENTS",
      "FETCH_APARTMENTS_BY_OBJECT",
    ]),
    ...mapActions("knowledgeBase", [
      "FETCH_PAYMENT_INTERESTS",
      "DELETE_PAYMENT_INTEREST",
      "CREATE_PAYMENT_INTEREST",
      "DELETE_PAYMENT_OPTION",
    ]),
    ...mapMutations("breadcrumb", ["UPDATE_BREADCRUMB"]),
    refresh() {
      this.FETCH_ONE_OBJECT(this.$route.params.id);
      this.FETCH_APARTMENTS_BY_OBJECT({ id: this.$route.params.id });
    },
    updateBreadcrumb() {
      const [first, second] = this.$_removeObjectConnection(
        this.$route.meta.breadcrumb
      );
      second.text = this.GET_OBJECT_MAIN_INFO.title;
      this.UPDATE_BREADCRUMB([first, second]);
    },
    deletePayment(id) {
      this.$_showAreYouSureModal().then((value) => {
        if (value) {
          this.DELETE_PAYMENT_INTEREST(id)
            .then(() => {
              this.$_successToast(this.$t("generals.deleted"));
              this.FETCH_OBJECT_CALCULATIONS(this.$route.params.id);
            })
            .catch(() => {
              this.$_errorToast(this.$t("generals.error"));
            });
        }
      });
    },
    deletePaymentOption(id) {
      this.$_showAreYouSureModal().then((value) => {
        if (value) {
          this.DELETE_PAYMENT_OPTION(id)
            .then(() => {
              this.$_successToast(this.$t("generals.deleted"));
              this.FETCH_OBJECT_CALCULATIONS(this.$route.params.id);
            })
            .catch(() => {
              this.$_errorToast(this.$t("generals.error"));
            });
        }
      });
    },
    deactivateObject() {
      this.$_showAreYouSureModal().then((value) => {
        if (value) {
          this.EDIT_OBJECT({ is_active: false, id: this.$route.params.id })
            .then(() => {
              this.$router.push({ name: "my-objects" });
              this.$_successToast(this.$t("generals.deleted"));
            })
            .catch(() => {
              this.$_errorToast(this.$t("generals.error"));
            });
        }
      });
    },
    saveInitialPayment() {
      this.CREATE_PAYMENT_INTEREST({
        value: this.new_initial_payment,
        object_id: Number(this.$route.params.id),
      })
        .then(() => {
          this.$bvModal.hide("add-object-calculations");
          this.$_successToast(this.$t("generals.added"));
          this.FETCH_OBJECT_CALCULATIONS(this.$route.params.id);
        })
        .catch(() => {
          this.$_errorToast(this.$t("generals.error"));
        });
    },
    saveClick() {
      this.ADD_OBJECT_DISCOUNT_OPTION(this.new_option)
        .then(() => {
          this.$bvModal.hide("add-discount-option");
          this.$_successToast(this.$t("generals.added"));
          this.FETCH_OBJECT_CALCULATIONS(this.$route.params.id);
        })
        .catch(() => {
          this.$_errorToast(this.$t("generals.error"));
        });
    },
    changeInstallmentDate() {
      this.EDIT_OBJECT({
        id: this.$route.params.id,
        installment_end_date: this.GET_ONE_OBJECT.installment_end_date,
      })
        .then(() => {
          this.FETCH_ONE_OBJECT(this.$route.params.id);
          this.$_successToast(this.$t("generals.changed"));
        })
        .catch(() => {
          this.$_errorToast(this.$t("generals.error"));
        });
    },
    openOptionModal(initial_payment) {
      this.new_option = {
        object: this.$route.params.id,
        payment_in_percent: initial_payment,
      };
      console.log(this.new_option);
    },
    saveRange(option) {
      const { id, start, end, discount } = option;
      const reqData = {
        id,
        area_start: start,
        area_end: end,
        discount_in_percent: discount,
      };
      this.EDIT_OBJECT_DISCOUNT_OPTION(reqData)
        .then(() => {
          this.$root.$emit("bv::hide::popover");
          this.FETCH_OBJECT_CALCULATIONS(this.$route.params.id);
          this.$_successToast(this.$t("generals.changed"));
        })
        .catch(() => {
          this.$_errorToast(this.$t("generals.error"));
        });
    },
    changePaymentTypes() {
      this.EDIT_OBJECT({
        id: this.$route.params.id,
        payment_type: this.GET_ONE_OBJECT.payment_type,
      }).then(() => {
        this.$_successToast(this.$t("generals.updated"));
        this.refresh();
      });
    },
  },
};
</script>

<style></style>
